import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CLASSICBUTTONBLOCK_LEGACY_FIELD_ORDER = [
  "type",
  "color",
  "label",
  "url",
  "button-size-y"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  classicButtonBlockDescriptor: _generatedClassicButtonBlockDescriptor,
  classicButtonBlockBlocDefinition,
  classicButtonBlockDashboardLayout,
  classicButtonBlockConfig,
  classicButtonBlockResolveConfig,
  classicButtonBlockProperties,
} = doodBlockConfig(
  {
    name: "Classic Button",
    componentType: 'ClassicButtonBlockComponent',
    category: 'content',
    hideFromPicker: true,
    description: "Classic Button.",
    keywords: [],
    allowed_in: ["GenericPage"],
    sharedFields: {}
  },

  () => ({
    type: propertyValue({
      type: 'select',
      value: "primary",
      options: {
        label: "pages.blocks.classic-button.type.label",
        multiple: false,
        choices: [
          {
            value: "primary",
            label: "pages.blocks.classic-button.type.options.primary",
          },
          {
            value: "light",
            label: "pages.blocks.classic-button.type.options.light",
          },
          {
            value: "outlined",
            label: "pages.blocks.classic-button.type.options.outlined",
          },
        ],
      },
    }),
    color: propertyValue({
      type: 'select',
      value: "primary",
      options: {
        label: "pages.blocks.classic-button.color.label",
        multiple: false,
        choices: [
          {
            value: "primary",
            label: "pages.blocks.classic-button.color.options.primary",
          },
          {
            value: "neutral",
            label: "pages.blocks.classic-button.color.options.neutral",
          },
          {
            value: "success",
            label: "pages.blocks.classic-button.color.options.success",
          },
          {
            value: "info",
            label: "pages.blocks.classic-button.color.options.info",
          },
          {
            value: "highligh",
            label: "pages.blocks.classic-button.color.options.highligh",
          },
        ],
      },
    }),
    label: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.classic-button.label.label",
      },
    }),
    url: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.classic-button.url.label",
        help: "pages.blocks.classic-button.url.help",
        placeholder: "pay-at-table/overview",
      },
    }),
    "button-size-y": propertyValue({
      type: 'select',
      value: "M",
      options: {
        label: "pages.blocks.classic-button.button-size-y.label",
        multiple: false,
        choices: [
          {
            value: "S",
            label: "pages.blocks.classic-button.button-size-y.options.S",
          },
          {
            value: "M",
            label: "pages.blocks.classic-button.button-size-y.options.M",
          },
          {
            value: "L",
            label: "pages.blocks.classic-button.button-size-y.options.L",
          },
        ],
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.classic-button.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.classic-button.fieldset.content.label",
            fields: ["label", "url"],
          },
          {
            legend: "pages.blocks.classic-button.fieldset.appearance.label",
            fields: ["type", "button-size-y", "color"],
          },
        ],
      },
    ],
  })
);

export function classicButtonBlockDescriptor(): IBlockDescriptor;
export function classicButtonBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function classicButtonBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedClassicButtonBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedClassicButtonBlockDescriptor, classicButtonBlockProperties, fieldOrder);
}

export {
  classicButtonBlockBlocDefinition,
  classicButtonBlockDashboardLayout,
  classicButtonBlockProperties,
  classicButtonBlockConfig,
  classicButtonBlockResolveConfig,
};

export type ClassicButtonBlockConfig = typeof classicButtonBlockConfig;
